import FieldsGetter from "components/fields/fields";
import MDTypography from "components/MDTypography";
import { tableFilterVariables } from "constants/forms/filter";
import { CloseOutlined } from '@ant-design/icons';
import { Button, } from 'antd';

export default function Filtros({ setFormData, formData, owners }) {

    const onChange = (id, value) => {
        setFormData(prev => ({ ...prev, [id]: value }))
    }


    return (
        <>
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                <MDTypography variant="h6" color="dark">
                    Filtros
                </MDTypography>
            </div>
            <div style={{ width: "100%", display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {
                    tableFilterVariables({ owners }).map((field) => {
                        return <FieldsGetter props={{ ...field, formData, onChange, setFormData, placement: "bottom" }} />
                    })
                }
                <Button
                    type="primary"
                    icon={<CloseOutlined />}
                    size="middle"
                    style={{ height: "36px" }}
                    onClick={() => setFormData({})}
                >
                    Limpar
                </Button>
            </div>
        </>
    )
}